import { Bluex, Success, typography, Warning } from "@bonusx-global/bx-design-system";
import type { AlertProps, Components, CSSInterpolation, Theme } from "@mui/material";

const MuiAlertOverridesMapper: Record<NonNullable<AlertProps["severity"]>, CSSInterpolation> = {
  error: {
    // NOTE: This needs to be added to the theme palette
    backgroundColor: `#D32F2F`,
    color: "#fff",
    fontFamily: typography.fontFamily,
  },
  success: {
    backgroundColor: Success.main,
    color: Success.contrastText,
    fontFamily: typography.fontFamily,
  },
  warning: {
    backgroundColor: Warning.main,
    color: Warning.contrastText,
    fontFamily: typography.fontFamily,
  },
  info: {
    backgroundColor: Bluex["600"],
    color: "#fff",
    fontFamily: typography.fontFamily,
  },
};

export const MuiAlertOverrides: NonNullable<Components<Theme>["MuiAlert"]> = {
  styleOverrides: {
    root: ({ ownerState }) => {
      if (!ownerState.severity) return undefined;
      return MuiAlertOverridesMapper[ownerState.severity];
    },
    action: {
      "& button": {
        color: "inherit",
      },
    },
  },
};
